export const getFirstName = (user?: { given_name?: string; name?: string }): string | undefined => {
  const givenName = user?.given_name?.trim();
  if (givenName) return givenName;

  const name = user?.name?.trim();
  if (!name || name.includes("@")) return undefined;

  return name.split(/\s+/)[0];
};
